const styles = {
  item: {
    paddingRight: {
      xs: '24px',
      xl: '40px',
    },
    paddingTop: {
      xs: '16px',
      xl: '0',
    },
    '&:nth-of-type(2n)': {
      paddingRight: {
        xs: 0,
        xl: '40px',
      },
    },
    '&:nth-of-type(1)': {
      paddingTop: {
        xs: '0',
      },
    },
    '&:nth-of-type(2)': {
      paddingTop: {
        xs: '0',
      },
    },
  },
  value: {
    minWidth: { xs: 68, lg: 98 },
    color: 'kit.text.mainInverse',
    marginBottom: {
      xs: '4px',
      xl: '8px',
    },
  },
};

export default styles;
